import styled, { keyframes } from "styled-components";
import floor from "../../assets/illustrations/hero-floor.png";
import leftBlue from "../../assets/illustrations/blue-cube.png";
import rightYellow from "../../assets/illustrations/yellow-cube-large.png";
import purpleTop from "../../assets/illustrations/purple-cube.png";
import pinkTop from "../../assets/illustrations/pink-cube.png";
import orangeBall from "../../assets/illustrations/orange-ball.png";
import floorBall from "../../assets/illustrations/white-ball-large.png";
import pinkFloorSquare from "../../assets/illustrations/pink-square.png";
import whiteFloorSquare from "../../assets/illustrations/white-square.png";
import { useDevice } from "../../hooks/use-device";

const reveal = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const StyledHeroIllustration = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const Floor = styled.img`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  opacity: 0;
  animation: ${reveal} 0.8s ease-out 0.2s forwards;
`;

const LeftBlue = styled.img`
  position: absolute;
  left: 19.3%;
  bottom: 39.6%;
  width: 33%;
  opacity: 0;
  animation: ${reveal} 0.8s ease-out 0.4s forwards;
`;

const RightYellow = styled.img`
  position: absolute;
  right: 14.3%;
  bottom: 40%;
  width: 25%;
  opacity: 0;
  animation: ${reveal} 0.8s ease-out 0.4s forwards;
`;

const PurpleTop = styled.img`
  position: absolute;
  right: 31%;
  bottom: 68%;
  width: 33%;
  opacity: 0;
  animation: ${reveal} 0.8s ease-out 0.6s forwards;
`;

const PinkTop = styled.img`
  position: absolute;
  right: 39.2%;
  bottom: 76%;
  width: 16.5%;
  opacity: 0;
  animation: ${reveal} 0.8s ease-out 0.8s forwards;
`;

const OrangeBall = styled.img`
  position: absolute;
  right: 43.2%;
  bottom: 39%;
  width: 8%;
  opacity: 0;
  animation: ${reveal} 0.8s ease-out 0.4s forwards;
`;

const FloorBall = styled.img`
  position: absolute;
  right: 13%;
  bottom: 16%;
  width: 16%;
  opacity: 0;
  animation: ${reveal} 0.8s ease-out 0.3s forwards;
`;

const PinkFloorSquare = styled.img`
  position: absolute;
  left: 3%;
  bottom: 7%;
  width: 27%;
  opacity: 0;
  animation: ${reveal} 0.8s ease-out 0.3s forwards;

  @media only screen and (max-width: 639px) {
    display: none;
  }
`;

const WhiteFloorSquare = styled.img`
  position: absolute;
  left: -4%;
  bottom: 19%;
  width: 19%;
  opacity: 0;
  animation: ${reveal} 0.8s ease-out 0.3s forwards;

  @media only screen and (max-width: 639px) {
    display: none;
  }
`;

const BlurredSquare = styled.img`
  position: absolute;
  top: 13%;
  left: 11%;
  width: 20%;
  filter: blur(2px);
  opacity: 0;
  animation: ${reveal} 0.8s ease-out 0.5s forwards;

  @media only screen and (max-width: 639px) {
    display: none;
  }
`;

interface Props {
  scrollPercent: number;
}

const HeroIllustration = ({ scrollPercent }: Props) => {
  const { isMobile } = useDevice();
  const mobileMultiplier = isMobile ? 0.5 : 1;

  return (
    <StyledHeroIllustration>
      <Floor src={floor} />
      <LeftBlue src={leftBlue} />
      <RightYellow src={rightYellow} />
      <PurpleTop
        src={purpleTop}
        style={{
          transform: `translate3d(0, calc(${scrollPercent} * -${
            100 * mobileMultiplier
          }px), 0)`,
        }}
      />
      <PinkTop
        src={pinkTop}
        style={{
          transform: `translate3d(0, calc(${scrollPercent} * -${
            200 * mobileMultiplier
          }px), 0)`,
        }}
      />
      <OrangeBall
        src={orangeBall}
        style={{
          transform: `translate3d(0, calc(${scrollPercent} * -${
            200 * mobileMultiplier
          }px), 0)`,
        }}
      />
      <FloorBall
        src={floorBall}
        style={{
          transform: `translate3d(0, calc(${scrollPercent} * ${
            100 * mobileMultiplier
          }px), 0)`,
        }}
      />
      <PinkFloorSquare src={pinkFloorSquare} />
      <WhiteFloorSquare
        src={whiteFloorSquare}
        style={{
          transform: `translate3d(0, calc(${scrollPercent} * -${
            100 * mobileMultiplier
          }px), 0)`,
        }}
      />
      <BlurredSquare
        src={whiteFloorSquare}
        style={{
          transform: `translate3d(0, calc(${scrollPercent} * ${
            200 * mobileMultiplier
          }px), 0)`,
        }}
      />
    </StyledHeroIllustration>
  );
};

export default HeroIllustration;
